const article = {
  id: 10,
  category: "Webinaires",
  title: "[Webinaire] Transformation digitale : Enjeux 2026 pour les PME",
  text: "Inscrivez-vous à notre webinaire gratuit pour comprendre les défis de la digitalisation et découvrir des solutions concrètes adaptées aux PME.",
  link: "/articles/webinaire-transformation-digitale-2026",
  date: "Décembre 2025",
  highlight: "Réservez votre place dès maintenant !"
};

export default article;
